var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2082 10.2618V16.9702C18.2082 17.2243 18.1072 17.4681 17.9275 17.6478C17.7478 17.8275 17.504 17.9285 17.2498 17.9285H5.74984C5.49567 17.9285 5.25192 17.8275 5.07219 17.6478C4.89247 17.4681 4.7915 17.2243 4.7915 16.9702V10.2618",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.958496 9.30345L10.2869 1.67128C10.6293 1.39134 11.0579 1.2384 11.5002 1.2384C11.9424 1.2384 12.371 1.39134 12.7134 1.67128L22.0418 9.30345",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8335 8.34521H31.6252C33.1502 8.34521 34.6127 8.95102 35.691 10.0294C36.7694 11.1077 37.3752 12.5702 37.3752 14.0952V21.7619",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 22.7202V31.3452C10.5415 32.8702 11.1473 34.3327 12.2256 35.4111C13.304 36.4894 14.7665 37.0952 16.2915 37.0952H22.0415",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5835 16.9702L37.3752 21.7619L42.1668 16.9702",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 27.5119L10.5417 22.7202L5.75 27.5119",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.875 35.1785C25.875 37.7202 26.8847 40.1578 28.6819 41.955C30.4791 43.7522 32.9167 44.7619 35.4583 44.7619C38 44.7619 40.4375 43.7522 42.2348 41.955C44.032 40.1578 45.0417 37.7202 45.0417 35.1785C45.0417 32.6369 44.032 30.1993 42.2348 28.4021C40.4375 26.6049 38 25.5952 35.4583 25.5952C32.9167 25.5952 30.4791 26.6049 28.6819 28.4021C26.8847 30.1993 25.875 32.6369 25.875 35.1785Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4585 39.0118V40.9285",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4585 29.4285V31.3451",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.625 39.0119H37.375C37.8833 39.0119 38.3708 38.8099 38.7303 38.4505C39.0897 38.0911 39.2917 37.6035 39.2917 37.0952C39.2917 36.5869 39.0897 36.0994 38.7303 35.7399C38.3708 35.3805 37.8833 35.1785 37.375 35.1785H33.5417C33.0333 35.1785 32.5458 34.9766 32.1864 34.6172C31.8269 34.2577 31.625 33.7702 31.625 33.2619C31.625 32.7535 31.8269 32.266 32.1864 31.9066C32.5458 31.5471 33.0333 31.3452 33.5417 31.3452H39.2917",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg5);
export default __webpack_public_path__ + "static/media/legalStepsImg5.ed58f0bef5c8340c73ca0f586ea587f6.svg";
export { ForwardRef as ReactComponent };